module.exports = __webpack_public_path__ + "fonts/effect-civil-war-stories-9576a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-civil-war-stories.svg
// module id = 721
// module chunks = 0